import type { Campaign } from '../campaignsApi';
import { campaignChannels, channelLabel } from '../campaignChannels';
import './campaign-channel-settings.css';
import { CampaignChannelStatuses } from './CampaignChannelStatuses';
import { CheckCampaignStatusButton } from './CheckCampaignStatusButton';

export function CampaignChannelSummary({ campaign }: { campaign: Campaign }) {
  return <div className="campaign-channel-summary">
    {campaignChannels(campaign).map(channel => {
      const id = channel === 'meta' ? campaign.meta_campaign_id : campaign.google_campaign_id;
      const error = channel === 'meta' ? campaign.meta_last_error : campaign.google_last_error;
      return <span key={channel} className="campaign-channel-badge" title={error || undefined}>
        {channelLabel(channel)}: {error ? 'Erro de sincronização' : id ? `ID ${id}` : 'Sem publicação vinculada'}
      </span>;
    })}
    <CampaignChannelStatuses campaign={campaign} />
    <CheckCampaignStatusButton campaign={campaign} />
  </div>;
}
